import React, { useState, useEffect } from "react";
import { Button, Dropdown, Menu } from "antd";
import * as XLSX from "xlsx";
import { printpdf } from "../Services/PrintService";
import { ExportOutlined } from "@ant-design/icons";
import { handleEncrypt, handleDecrypt, anonymizeIdentifier, anonymizeName } from "../Utils/Utils"; // Assurez-vous que le chemin est correct
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService"; // Importez le service

const ExportOptions = ({ data, url }) => {
  const participantsIpmService = new ParticipantsIpmService();

  const prepareParticipantsDataForExport = (data) => {
    return data.map(participant => {
      const { matricule, ...rest } = participant; // Exclude 'matricule'
      return {
        ...rest,
        numcont: anonymizeIdentifier(participant.numcont),
        nom: anonymizeName(participant.nom),
        prenom: anonymizeName(participant.prenom),
      };
    });
  };

  const exportParticipantsToExcel = (data) => {
    //const anonymizedData = prepareParticipantsDataForExport(data);
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Participants');
    XLSX.writeFile(workbook, 'Participants.xlsx');
  };

  const exportToExcel = () => {
    exportParticipantsToExcel(data);
  };

  const exportToPDF = async () => {
    try {
      const filteredData = await participantsIpmService.printList(data); // Appel à l'API pour récupérer les données
      printpdf(url);
    } catch (error) {
      console.error('Erreur lors de l\'exportation en PDF :', error);
    }
  };

  const handleExport = (type) => {
    switch (type) {
      case "excel":
        exportToExcel();
        break;
      case "pdf":
        exportToPDF();
        break;
      default:
        break;
    }
  };

  const menu = (
    <Menu onClick={(e) => handleExport(e.key)}>
      <Menu.Item key="excel">Excel</Menu.Item>
      <Menu.Item key="pdf">PDF</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} placement="bottomCenter">
      <Button className='buttonExport' size="small" icon={<ExportOutlined />}>Export</Button>
    </Dropdown>
  );
};

export default ExportOptions;
